/* eslint-disable no-nested-ternary */
import styled, { css } from 'styled-components'

export const getInputBorderColor = props => {
  if (props.isFocused) {
    return props.theme.colors.grey3
  }

  if (props.error) {
    return props.theme.colors.failure
  }

  return props.theme.colors.grey5
}

export const autofillStyles = css`
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
    box-shadow: 0 0 0 30px transparent inset;
    transition: background-color 5000s ease-in-out 0s;
  }
`

export const getInputBackgroundColor = props => {
  if (props.disabled) {
    return props.theme.colors.grey5
  }

  if (props.error) {
    return 'var(--color--semantic--error--50)'
  }

  return ''
}

export const InputWrapper = styled.div`
  display: flex;
  align-items: center;

  border: 2px solid ${props => getInputBorderColor(props)};
  border-radius: 8px;
  position: relative;
  background-color: ${props => getInputBackgroundColor(props)};

  &:hover {
    border: 2px solid ${props => props.theme.colors.grey3};
  }

  svg {
    margin-block: 10px;
    margin-inline: 8px 14px;
    fill: ${props => props.theme.colors.grey3};
    flex: 0 0 auto;
  }
`

const labelWithiconTransitioned = css`
  transform: translate(calc(var(--transform-direction) * -60px), -35px) scale(0.75);
`

const labelTransitioned = css`
  transform: translate(calc(var(--transform-direction) * -14px), -35px) scale(0.75);
`

const getLabelBackgroundColor = props => {
  if (props.isTransitioned) {
    return !props.withIcon ? labelTransitioned : labelWithiconTransitioned
  }

  return css`
    background-color: transparent;
  `
}

export const LabelText = styled.span`
  white-space: nowrap;
  position: absolute;
  inset-block-start: 50%;
  inset-inline-start: 10px;
  transform: translateY(-50%);
  padding-block: 3px;
  padding-inline: 5px;
  background-color: ${props => props.theme.colors[props.background]};
  transition:
    transform 0.1s,
    background-color 0.1s;

  ${props => getLabelBackgroundColor(props)}

  background-color: ${props => props.theme.colors.grey8};
`

export const Label = styled.label`
  display: block;
  font-family: ${props => props.theme.fonts.families.primary};
  width: 100%;
  position: relative;
  color: ${props => props.theme.colors.grey3};

  &:focus-within ${LabelText} {
    ${props => (!props.withIcon ? labelTransitioned : labelWithiconTransitioned)}
  }

  ${autofillStyles}
`

export const InputElement = styled.input`
  padding-block: 12px;
  padding-inline: 14px;
  width: 100%;
  font-weight: 700;
  border: none;
  border-radius: 8px;

  &:focus {
    outline: none;
  }

  &:disabled {
    background-color: ${props => props.theme.colors.grey5};
    color: ${props => props.theme.colors.grey3};
  }
`

export const InputRadioWrapper = styled.div`
  width: 100%;
`

export const LabelRadio = styled.label`
  cursor: pointer;
  display: flex;
  align-items: center;
  color: ${props => props.theme.colors.grey3};
`

export const InputRadio = styled.input`
  box-sizing: content-box;
  position: relative;
  appearance: none;
  outline: none;
  background-color: transparent;
  width: 21px;
  height: 21px;
  padding-block: 0;
  padding-inline: 0;
  margin-block: 0;
  margin-inline: 0 12px;
  border-radius: 100%;
  background-color: ${props => props.theme.colors.grey5};
  flex: 0 0 auto;

  &:checked {
    background-color: ${props => props.theme.colors.brand1};
    &::after {
      background-color: ${props => props.theme.colors.brand1};
    }
  }

  &::after {
    content: '';
    position: absolute;
    width: 9px;
    height: 9px;
    background-color: ${props => props.theme.colors.grey8};
    border: 4px solid ${props => props.theme.colors.grey8};
    border-radius: 100%;
    inset-inline-start: 2px;
    inset-block-start: 2px;
  }
`
